import { Injectable } from "@angular/core";
import { Alert } from "@shared/schemas/alert";
import { Subject } from "rxjs";

interface SingleAlert {
	key: string;
	message: string;
	title?: string;
}

@Injectable({ providedIn: "root" })
export class AlertsService {
	private alerts = new Subject<Alert[] | Alert>();
	alerts$ = this.alerts.asObservable();

	/**
	 * @deprecated Método depreciado. Caso necesário utilizar o método showAlertsByGroup()
	 */
	addAlerts(alerts: Alert[] | Alert): void {
		this.alerts.next(alerts);
	}

	showAlertsByGroup(alerts: Alert[]): void {
		this.alerts.next(alerts);
	}

	success({ key, message, title }: SingleAlert): void {
		const alert: Alert = { message, key, severity: "success", title };
		this.alerts.next(alert);
	}

	error({ key, message, title }: SingleAlert): void {
		const alert: Alert = { message, key, severity: "danger", title };
		this.alerts.next(alert);
	}

	warning({ key, message, title }: SingleAlert): void {
		const alert: Alert = { message, key, severity: "warning", title };
		this.alerts.next(alert);
	}

	info({ key, message, title }: SingleAlert): void {
		const alert: Alert = { message, key, severity: "info", title };
		this.alerts.next(alert);
	}
}
